import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ff-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/manuel/Sites/doxasoft/fenyofarm/csemete/src/app/footer/footer.component.ts